module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/babel-loader/lib/index.js!./symbols.js"));
	}, "home-symbols");
}


//////////////////
// WEBPACK FOOTER
// ./~/bundle-loader?lazy&name=home-symbols!./src/pages/home/symbols.js
// module id = 90
// module chunks = 8